export enum STATUS {
  ready = 'ready',
  redirecting = 'redirecting',
  loading = 'loading',
}

export const SKIP_RECONNECT_SESSION_KEY = 'skip-reconnect';
